import ChildcareService from '@/services/childcareService';

export default {
  saveP1StripeConnectedAccountLink({ commit, dispatch }: any, data: any) {    
    return ChildcareService.saveP1StripeConnectedAccountLink(data).then(success => {
      commit("setChildcareEnrollmentStep", success.data);

      return Promise.resolve(success.data);
    }, error => {
      return Promise.reject(error);
    })
  },
  updateP1StripeConnectedAccountLink({ commit, dispatch }: any, data: any) {
    return ChildcareService.updateP1StripeConnectedAccountLink(data).then(success => {
      return Promise.resolve(success.data);
    }, error => {
      return Promise.reject(error);
    })
  },
  saveHouseholdInfo({ commit, dispatch }: any, data: any) {
    return ChildcareService.saveHouseholdInfo(data).then(success => {
      commit("setChildcareEnrollmentStep", success.data);
      commit('updateHousehold', data);

      return Promise.resolve(success.data);
    }, error => {
      return Promise.reject(error);
    })
  },
  updateHouseholdInfo({ commit, dispatch }: any, data: any) {
    return ChildcareService.updateHouseholdInfo(data).then(success => {
      commit('updateHousehold', data);

      return Promise.resolve();
    }, error => {
      return Promise.reject(error);
    })
  },
  saveProgramStatement({ commit, dispatch }: any, data: string) {
    return ChildcareService.saveProgramStatement(data).then(success => {
      commit("setChildcareEnrollmentStep", success.data);
      commit('updateProgramStatement', data);

      return Promise.resolve(success.data);
    }, error => {
      return Promise.reject(error);
    })
  },
  saveBadges({ commit, dispatch }: any, data: any) {
    return ChildcareService.saveBadges(data).then(success => {
      commit("setChildcareEnrollmentStep", success.data.stepsCompleted);

      //Updates separately in the 'updateBadges'
      //commit("updateBadges", success.data.badges);

      return Promise.resolve(success.data);
    }, error => {
      return Promise.reject(error);
    })
  },
  updateBadges({ commit, dispatch }: any, data: any) {
    return ChildcareService.updateBadges(data)
      .then(success => {
        let badges = success.data.badges;
        let isOnlyBadges = eval(data.get("isOnlyBadges"));
        let badgesNames = data.get("badgesNames");

        commit("updateBadges", {
          badges: badges,
          isOnlyBadges: isOnlyBadges,
          badgesNames: badgesNames
        });

        return Promise.resolve(success.data);
      }
      , error => {
      return Promise.reject(error);
    })
  },
  saveFamilyAmenities({ commit, dispatch }: any, data: any) {
    return ChildcareService.saveFamilyAmenities(data).then(success => {
      commit("setChildcareEnrollmentStep", success.data);

      return Promise.resolve(success.data);
    }, error => {
      return Promise.reject(error);
    })
  },
  updateFamilyAmenities({ commit, dispatch }: any, data: any) {
    return ChildcareService.updateFamilyAmenities(data).then(success => {
      commit("updateFamilyAmenities", data);

      return Promise.resolve(success.data);
    }, error => {
      return Promise.reject(error);
    })
  },
  updateHomeSafety({ commit, dispatch }: any, data: any) {
    return ChildcareService.updateHomeSafety(data).then(success => {
      commit("updateHomeSafety", data);

      return Promise.resolve(success.data);
    }, error => {
      return Promise.reject(error);
    })
  },
  saveHomeSafety({ commit, dispatch }: any, data: any) {
    return ChildcareService.saveHomeSafety(data).then(success => {
      commit("setChildcareEnrollmentStep", success.data);
      commit("updateHomeSafety", data);

      return Promise.resolve(success.data);
    }, error => {
      return Promise.reject(error);
    })
  },
  saveChildcareLocation({ commit, dispatch }: any, data: any) {
    return ChildcareService.saveChildcareLocation(data).then(success => {
      commit("setChildcareEnrollmentStep", success.data);

      return Promise.resolve(success.data);
    }, error => {
      return Promise.reject(error);
    });
  },
  updateChildcareLocation({ commit, dispatch }: any, data: any) {
    return ChildcareService.updateChildcareLocation(data).then(success => {
      commit("updateChildcareLocation", data);

      return Promise.resolve(success.data);
    }, error => {
      return Promise.reject(error);
    })
  },
  saveParentBookingMethod({ commit, dispatch }: any, data: boolean) {
    return ChildcareService.saveParentBookingMethod(data).then(success => {
      commit("setChildcareEnrollmentStep", success.data);
      commit("updateParentBookingMethod", data);

      return Promise.resolve(success.data);
    }, error => {
      return Promise.reject(error);
    })
  },
  updateParentBookingMethod({ commit, dispatch }: any, data: boolean) {
    return ChildcareService.updateParentBookingMethod(data).then(success => {
      commit("updateParentBookingMethod", data);

      return Promise.resolve(success.data);
    }, error => {
      return Promise.reject(error);
    })
  },
  saveAvailabilitySettings({ commit, dispatch }: any, data: boolean) {
    return ChildcareService.saveAvailabilitySettings(data).then(success => {
      commit("setChildcareEnrollmentStep", success.data);
      commit("updateAvailabilitySettings", success.data);

      return Promise.resolve(success.data);
    }, error => {
      return Promise.reject(error);
    })
  },
  updateAvailabilitySettings({ commit }: any, data: boolean) {
    return ChildcareService.updateAvailabilitySettings(data).then(success => {
      commit("updateAvailabilitySettings", data);

      return Promise.resolve(success.data);
    }, error => {
      return Promise.reject(error);
    })
  },
  saveAcceptedAgeGroups({ commit, dispatch }: any, data: any) {
    return ChildcareService.saveAcceptedAgeGroups(data).then(success => {
      commit("setChildcareEnrollmentStep", success.data);
      commit("updateAcceptedAgeGroups", data)

      return Promise.resolve(success.data);
    }, error => {
      return Promise.reject(error);
    });
  },
  updateAcceptedAgeGroups({ commit, dispatch }: any, data: any) {
    return ChildcareService.updateAcceptedAgeGroups(data).then(success => {
      commit("updateAcceptedAgeGroups", data)

      return Promise.resolve(success.data);
    }, error => {
      return Promise.reject(error);
    });
  },
  getAcceptedAgeGroups({ commit }: any) {
    return ChildcareService.getAcceptedAgeGroups().then(success => {
      commit("updateAcceptedAgeGroups", success.data)

      return Promise.resolve(success.data);
    }, error => {
      return Promise.reject(error);
    });
  },
  saveHoursOfBusiness({ commit, dispatch }: any, data: any) {
    return ChildcareService.saveHoursOfBusiness(data).then(success => {
      commit("setChildcareEnrollmentStep", success.data);
      commit("updateHoursOfBusiness", data.hoursOfBusiness);

      return Promise.resolve(success.data);
    }, error => {
      return Promise.reject(error);
    });
  },
  updateHoursOfBusiness({ commit }: any, data: any) {
    return ChildcareService.updateHoursOfBusiness(data).then(success => {
      commit("updateHoursOfBusiness", data.hoursOfBusiness);

      return Promise.resolve(success.data);
    }, error => {
      return Promise.reject(error);
    });
  },
  savePrices({ commit, dispatch }: any, data: any) {
    return ChildcareService.savePrices(data).then(success => {
      commit("setChildcareEnrollmentStep", success.data);
      commit("updatePrices", data);

      return Promise.resolve(success.data);
    }, error => {
      return Promise.reject(error);
    });
  },
  updatePrices({ commit, dispatch }: any, data: any) {
    return ChildcareService.updatePrices(data).then(success => {
      commit("updatePrices", data);

      return Promise.resolve(success.data);
    }, error => {
      return Promise.reject(error);
    });
  },
  setAvailableSpaces({ commit, dispatch }: any, data: any) {
    return ChildcareService.setAvailableSpaces(data).then(success => {
      return Promise.resolve(success.data);
    }, error => {
      return Promise.reject(error);
    });
  },
  getAvailableSpaces({ commit }: any) {
    return ChildcareService.getAvailableSpaces().then(success => {
      return Promise.resolve(success.data);
    }, error => {
      return Promise.reject(error);
    });
  },
  saveCancellationOptions({ commit, dispatch }: any, data: any) {
    return ChildcareService.saveCancellationOptions(data).then(success => {
      commit("setChildcareEnrollmentStep", success.data);
      commit("updateCancellationOptions", data);

      return Promise.resolve(success.data);
    }, error => {
      return Promise.reject(error);
    });
  },
  updateCancellationOptions({ commit, dispatch }: any, data: any) {
    return ChildcareService.updateCancellationOptions(data).then(success => {
      commit("updateCancellationOptions", data);

      return Promise.resolve(success.data);
    }, error => {
      return Promise.reject(error);
    });
  },
  savePoliciesAndProcedures({ commit, dispatch }: any, data: any) {
    return ChildcareService.savePoliciesAndProcedures(data.formData).then(success => {
      commit("setChildcareEnrollmentStep", success.data);
      commit("updatePolicies", data.data.policiesAndProcedures);

      return Promise.resolve(success.data);
    }, error => {
      return Promise.reject(error);
    });
  },
  updatePoliciesAndProcedures({ commit, dispatch }: any, data: any) {
    return ChildcareService.updatePoliciesAndProcedures(data.formData).then(success => {
      commit("setChildcareEnrollmentStep", success.data);
      commit("updatePolicies", data.data.policiesAndProcedures);

      return Promise.resolve(success.data);
    }, error => {
      return Promise.reject(error);
    });
  },
  updatePoliciesAndProceduresFiles({ commit, dispatch }: any, data: any) {
    return ChildcareService.updatePoliciesAndProceduresFiles(data.formData).then(success => {
      return Promise.resolve(success.data);
    }, error => {
      return Promise.reject(error);
    });
  },
  saveNotifications({ commit, dispatch }: any, data: any) {
    return ChildcareService.saveNotifications(data).then(success => {
      commit("setChildcareEnrollmentStep", success.data);
      commit("updateNotifications", data);

      return Promise.resolve(success.data);
    }, error => {
      return Promise.reject(error);
    });
  },
  updateNotifications({ commit }: any, data: any) {
    return ChildcareService.updateNotifications(data).then(success => {
      commit("updateNotifications", data);

      return Promise.resolve(success.data);
    }, error => {
      return Promise.reject(error);
    });
  },
  updateProgramStatement({ commit, dispatch }: any, data: any) {
    return ChildcareService.updateProgramStatement(data).then(success => {
      commit("updateProgramStatement", data);
      
      return Promise.resolve(success.data);
    }, error => {
      return Promise.reject(error);
    })
  },
  getHistory({ commit }: any) {
    return ChildcareService.getProviderHistory().then(success => {
      return Promise.resolve(success);
    }, error => {
      return Promise.reject(error);
    });
  },
  clear(context: any) {
    context.commit('clear');
  },
  saveHolidays({ commit, dispatch }: any, data: any) {
    return ChildcareService.saveHolidays(data).then(success => {
      return Promise.resolve(success);
    }, error => {
      return Promise.reject(error);
    });
  },
  getIsGeolocationShared({ commit }: any) {
    return ChildcareService.getIsGeolocationShared()
      .then(
        (success: any) => {
          return Promise.resolve(success.data);
        },
        (error: any) => {
          return Promise.reject(error);
        }
      );
  },
  setIsGeolocationShared({ commit }: any, data: any) {
    return ChildcareService.setIsGeolocationShared(data)
      .then(
        (success: any) => {
          commit("setChildcareEnrollmentStep", success.data);

          return Promise.resolve(success);
        },
        (error: any) => {
          return Promise.reject(error);
        }
      );
  },
  getProviderForCurrentUser({ commit }: any) {
    return ChildcareService.getProviderForCurrentUser()
      .then(
        (success: any) => {
          commit("setProviderForCurrentUser", success.data);

          return Promise.resolve(success.data);
        },
        (error: any) => {
          return Promise.reject(error);
        }
      );
  },
  setAcceptBooking({ commit }: any, data: any) {
    commit("setAcceptBooking", data);

    return new Promise((resolve, reject) =>
    {
        return resolve(data);
    });
  }, 
  setRejectBooking({ commit }: any, data: any) {
    commit("setRejectBooking", data);

    return new Promise((resolve, reject) =>
    {
        return resolve(data);
    });
  },
}